module.exports = __webpack_public_path__ + "static/media/grand_mum_talking_perfect.6e99e250.png";